import React from "react";

import {
  Box,
  IconButton,
} from "@mui/material";
import {
  AddCircle,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";

import {
  HelpBox,
  QueryGroup,
  QueryGroupOperator, TitleText,
} from "@/components/atoms";
import { useAudienceActions, useBuilder } from "@/context";
import { BuildAudience } from "@/types";


interface StandardBuilderProps {
  audience: BuildAudience;
}

const StandardBuilder: React.FC<StandardBuilderProps> = ({ audience }) => {

  const audienceActions = useAudienceActions();
  const { disabled } = useBuilder();

  const numQueryGroups = audience.var_groups.length;

  const handleAddGroup = () => {
    audienceActions.addGroup();
  };

  const handleChangeOperator = (event: React.ChangeEvent<HTMLInputElement>) => {
    audienceActions.setOperator(event.target.value);
  };

  return (
    <>
      <Grid size={12}>
        <TitleText
          text="Who are your Audience?"
          subtext="Describe your audience by their behaviours. A query group is a set of variables that are combined using a boolean operator (e.g. AND/OR) to define an audience behaviour"
          variant="body1"
          spacing={0.5}
        />
      </Grid>
      {audience.var_groups.map((group, index) => (
        <React.Fragment key={index}>
          {/*TODO - Reset needs to revert back to previous state not clear - or call it clear*/}
          <QueryGroup group={group} numQueryGroups={numQueryGroups} />
          {numQueryGroups > 1 && index + 1 !== numQueryGroups && (
            <Grid size={12}>
              <QueryGroupOperator
                value={audience.operator}
                onChange={handleChangeOperator}
                disabled={disabled}
              />
            </Grid>
          )}
        </React.Fragment>
      ))}
      {!disabled && (
        <Grid size={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            border={1}
            borderRadius={1}
            borderColor="divider"
            p={1}
          >
            <HelpBox title="Add Query Group">
              <IconButton size="small" onClick={handleAddGroup}>
                <AddCircle color="secondary" />
              </IconButton>
            </HelpBox>
          </Box>
        </Grid>
      )}
      {/*<Grid size={12} mt={2}>*/}
      {/*  <HelpText*/}
      {/*    text="Audience Settings"*/}
      {/*    helpText="Additional settings to configure your audience further"*/}
      {/*    variant="body1"*/}
      {/*  />*/}
      {/*</Grid>*/}
      {/*<Grid>*/}
      {/*  <BuildModeSelect*/}
      {/*    value={audience.build_mode}*/}
      {/*    onChange={handleChangeMode}*/}
      {/*    disabled={disabled}*/}
      {/*  />*/}
      {/*</Grid>*/}
      {/*<Grid>*/}
      {/*  <LocationSelection*/}
      {/*    locations={locations}*/}
      {/*    selection={audience.geo_fence}*/}
      {/*    onSelect={handleSelectLocation}*/}
      {/*    disabled={disabled}*/}
      {/*  />*/}
      {/*</Grid>*/}
    </>
  );
};

export default StandardBuilder;
